import React, { useState, useEffect } from "react";
import * as yup from "yup";
import { Formik } from "formik";
import { DialogActions, IconButton, InputAdornment } from "@material-ui/core";
import { CustomTextField } from "../../partials/content/Forms";
import { onPreventEnterSubmitting } from "../../utils/utils";
import { updateCompanyProfileAdminPassword } from "../../services/setup/company-profile/companyProfileService";
import { Typography } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Swal from "sweetalert2";
import BootstrapTooltip from "../../partials/content/BootstrapTooltip";
const ChangeAdminPassword = ({
  activeStep,
  handleBack,
  handleSkip,
  handleNext,
  companyProfile,
  handleReloadCompanyProfile,
}) => {
  const [adminData, setAdminData] = useState({
    email: "",
    phone: "",
    newPassword: "",
    confirmPassword: "",
    showNewPassword: false,
    showConfirmPassword: false,
  });

  useEffect(() => {}, []);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const changeAdminPasswordFormSchema = yup.object().shape({
    phone: yup
      .string()
      .required("Phone Number is required")
      .matches(
        /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
        "Phone Number must be valid. e.g. +6281XXXXXXX or 081XXXXXXX"
      )
      .max(50, "Phone Number maximum characters is 50"),
    email: yup
      .string()
      .email("Email must be valid. e.g. joe@invifo.com")
      .required("Email is required")
      .max(50, "Email maximum characters is 50"),
    newPassword: yup.string().required("Password is required"),
    confirmPassword: yup
      .string()
      .when("newPassword", {
        is: (val) => (val && val.length > 0 ? true : false),
        then: yup.string().required("Please confirm Password"),
      })
      .when("newPassword", {
        is: (val) => (val && val.length > 0 ? true : false),
        then: yup
          .string()
          .oneOf(
            [yup.ref("newPassword")],
            "Password confirmation does not match"
          ),
      }),
  });
  return (
    <Formik
      initialValues={adminData}
      validationSchema={changeAdminPasswordFormSchema}
      enableReinitialize={true}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title:
              "Are you sure want to update this Default Administrator Contact & Password ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, update it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              updateCompanyProfileAdminPassword(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Updated",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                handleReloadCompanyProfile();
                handleNext();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <div className="horizontal-step-content">
            <div className="row justify-content-center">
              <div className="col-sm-4 col-md-4 col-lg-4">
                <div className="column">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <CustomTextField
                      label="Email"
                      inputType="text"
                      propertyName="email"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      values={values}
                      touched={touched}
                      errors={errors}
                      size="small"
                    />
                    <CustomTextField
                      label="Phone Number"
                      inputType="text"
                      propertyName="phone"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      values={values}
                      touched={touched}
                      errors={errors}
                      size="small"
                    />
                    <CustomTextField
                      label="New Password"
                      inputType={values.showNewPassword ? "text" : "password"}
                      propertyName="newPassword"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      values={values}
                      touched={touched}
                      endAdornment={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <BootstrapTooltip
                              title={
                                values.showNewPassword
                                  ? "Hide New Password"
                                  : "Show New Password"
                              }
                            >
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => {
                                  setAdminData({
                                    ...values,
                                    showNewPassword: !adminData.showNewPassword,
                                  });
                                }}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                              >
                                {values.showNewPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </BootstrapTooltip>
                          </InputAdornment>
                        ),
                      }}
                      errors={errors}
                      size="small"
                    />
                    <CustomTextField
                      label="Confirm Password"
                      inputType={
                        values.showConfirmPassword ? "text" : "password"
                      }
                      propertyName="confirmPassword"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      values={values}
                      touched={touched}
                      endAdornment={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <BootstrapTooltip
                              title={
                                values.showConfirmPassword
                                  ? "Hide Confirm Password"
                                  : "Show Confirm Password"
                              }
                            >
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => {
                                  setAdminData({
                                    ...values,
                                    showConfirmPassword: !adminData.showConfirmPassword,
                                  });
                                }}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                              >
                                {values.showConfirmPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </BootstrapTooltip>
                          </InputAdornment>
                        ),
                      }}
                      errors={errors}
                      size="small"
                    />
                    <Typography align="center" className="mt-2">
                      Note: The System Administrator email will be used for
                      platform access recovery in case you lose access to System
                      Administrator.
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <DialogActions>
            <button
              type="button"
              className="btn btn-warning btn-md btn-pill btn-bold"
              onClick={handleBack}
              disabled={activeStep === 0}
            >
              <i className="fas fa-arrow-circle-left"></i>
              Back
            </button>
            <button
              type="submit"
              className="btn btn-primary btn-md btn-pill btn-bold"
              disabled={isSubmitting}
            >
              <i className="fas fa-arrow-circle-right"></i>
              Next
            </button>
          </DialogActions>
        </form>
      )}
    </Formik>
  );
};

export default ChangeAdminPassword;
